export default function UpdatesSection() {
  const updates = [
    {
      date: '2026-08-01',
      title: '《长安十二时辰》第二季全36集上线',
      desc: '古装悬疑巨制完整版一次性放出，极速影视全网首播，4K超清画质畅快追剧',
      type: '上线',
    },
    {
      date: '2026-07-30',
      title: '播放器全面升级至V3.0版本',
      desc: '新增智能倍速、记忆续播、弹幕优化等功能，观影体验大幅提升',
      type: '更新',
    },
    {
      date: '2026-07-28',
      title: '动漫专区新增200+部日漫资源',
      desc: '《咒术回战》《鬼灭之刃》《进击的巨人》等热门番剧全集上线',
      type: '上线',
    },
    {
      date: '2026-07-25',
      title: 'CDN节点扩容至全国350个',
      desc: '西北和西南区域播放速度再提升40%，实现全国无死角极速不缓冲体验',
      type: '优化',
    },
    {
      date: '2026-07-22',
      title: 'iOS客户端3.2.0版本发布',
      desc: '支持画中画播放、Siri快捷指令、锁屏控件，iOS用户追剧更加便捷',
      type: '更新',
    },
    {
      date: '2026-07-18',
      title: '纪录片专区重磅升级',
      desc: 'BBC、国家地理、Discovery最新纪录片同步收录，超500部高清纪录片免费看',
      type: '上线',
    },
    {
      date: '2026-07-15',
      title: '上线智能推荐算法2.0',
      desc: '基于观影历史和偏好的个性化推荐，帮你发现更多符合口味的优质好剧',
      type: '优化',
    },
    {
      date: '2026-07-10',
      title: '弹幕系统全新改版',
      desc: '新增彩色弹幕、防遮挡模式和智能过滤，追剧互动体验全面进化',
      type: '更新',
    },
    {
      date: '2026-07-05',
      title: '极速影视总用户突破5000万',
      desc: '感谢每一位用户的支持与信任，我们将继续努力提供更优质的追剧体验',
      type: '里程碑',
    },
  ];

  const getTypeStyle = (type: string) => {
    switch (type) {
      case '上线':
        return 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30';
      case '更新':
        return 'bg-accent-500/15 text-accent-400 border-accent-500/30';
      case '优化':
        return 'bg-blue-400/15 text-blue-400 border-blue-400/30';
      case '里程碑':
        return 'bg-primary-500/15 text-primary-400 border-primary-500/30';
      default:
        return 'bg-secondary-500/15 text-secondary-400 border-secondary-500/30';
    }
  };

  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500">极速影视平台动态与内容更新实时追踪</p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-200"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 pl-12">
                {/* Timeline dot */}
                <div className="absolute left-[15px] top-1.5 w-2.5 h-2.5 rounded-full bg-accent-500 ring-2 ring-background-50"></div>

                <div className="flex-1 min-w-0 bg-background-100 rounded-xl border border-background-200/50 p-5 hover:border-accent-500/20 transition-all duration-200 cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded-md border whitespace-nowrap ${getTypeStyle(item.type)}`}>
                      {item.type}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-100 mb-1.5">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}